import React, {Component} from 'react';
import { View, Text} from 'react-native';

import ff from './ff';
import cf from './cf';
import ce from './ce';
import ic from './ic';
import bf from './bf';
//import iv from './iv';

import df from './df_20211115';

import c00v from './c00v_20211024';
import c10v1a from './c10v1a';

export default class c00v2 extends c00v {

$id_stss = {
  sn_key: '',
  s_pwd: '',
};

static cd_stgs = {
};

$ilp_loadLists = () => [
  c10v1a.op_loadSlcList({
    elm: 'c10r',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c10r', `c10rt11i = 20`, false, false)
      return _cnd;
    }
  })
];

render() {
  return (
    ce.c(ce.RootDtl, {
      d_hdrs: {
        d_lefts: {
          b_vsb: false,
        }
      },
      d_bdys: {
        d_stlCtas: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            d_btms: {
              l_clds: [
                ce.c(ce.Msg, {
                  key: -5,
                  pfx:`＊ 地域ケアプラザ施設管理支援システム　C-サポート ＊`,
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1),
                  },
                }),
              ]
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              },
              l_clds: [


                ce.c(ce.Img, {
                  key: -3,
                  uri: `${ic.g_url2}/login-head.jpeg`,
                  d_stlCtas: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  },
                  d_stlImgs: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  }
                }),

/*
                ce.c(ce.Msg, {
                  key: -5,
//                  pfx:`施設予約管理システム`,
                  pfx:`${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}\n施設予約管理システム`,
                  b_vsb: true,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold',
                  },
                }),
*/

                ce.c(ce.Msg, {
                  key: -5,
                   pfx:`${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理`,
                   b_vsb: (global.t?.state.sgcd_cmnStgs?.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.6),
                    fontWeight: 'bold',
                    color: ic.o_getCcd('d'),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -10,
//                  pfx:`▼利用者を選択した後、パスワードを入力し、［送る］ボタンを押してください。`,
                  pfx:`▼利用者を選択した後、パスワードを入力し、［ログイン］ボタンを押してください。`,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Pck, {
                  key: -20,
                  pfx: '利用者',
                  state: 'sn_key',
                  b_edit: true,
                  ld_iss: global.t?.state.sdld_c10rSlcListsss?.c10r,
                  n_col: 20,
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),

                ce.c(ce.Inp, {
                  key: -30,
                  pfx: 'パスワード',
                  state: 's_pwd',
                  b_edit: true,
                  b_pwd: true,
                  n_col: 20,
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),
                ce.c(ce.Btn, {
                  key: -40,
//                  pfx: '送る',
                  pfx: 'ログイン',
                  n_col: 10,
                  o_onPrs: () => {
                    //let _cnd = cf.c('c10r', `t_c10r.c10rt11i = 20 AND t_c10r._key = ${global.t?.state.sn_key} AND t_c10r.c10rc02s = "${global.t?.state.s_pwd}"`, false, false)
                    //let _cnd = cf.c('c10r', `t_c10r.c10rt11i = 20 AND t_c10r._key = ${ff.myCM_cnv('trim', global.t?.state.sn_key)} AND t_c10r.c10rc02s = "${ff.myCM_cnv('trim', global.t?.state.s_pwd)}"`, false, false)
                    let _cnd = cf.c('c10r', `t_c10r.c10rt11i = 20 AND t_c10r._key = ${ff.myCM_cnv('trim', global.t?.state.sn_key)} AND t_c10r.c10rc02s = "${ff.myCM_cnv('trim', global.t?.state.s_pwd)}"`, false, false)
                    c10v1a.op_loadDtl({
                      elm: 'c10r',
                      o_cnd: _dd_datss => _cnd,
                    })
                    .then(() => {
                      if (ff.f(global.t?.state.sdld_c10rDtlsss.c10r)) {
                        let _d_c10rs = global.t?.state.sdld_c10rDtlsss.c10r[0];
                        c00v2._setC10rs(_d_c10rs.d_flds, true);
                      }
                      else {
                        alert('認証に失敗しました')
                      };
                    })                    
                  },
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  }
                })

              ],
            },
          })

        ],
      },
    })
  );
};

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
